import React, { useState } from 'react';
import '../components/CourseVideo.css'; // Import CSS file

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.5rem 2rem',
    background: '#1d212b',
    color: '#fff',
    borderRadius: '8px',
    backgroundColor: '#2fb2e7',
    marginBottom: '2rem',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
  },
  headerTitle: {
    margin: 0,
    fontSize: '1.5rem',
    fontWeight: 600,
    letterSpacing: '0.5px',
  },
  addButton: {
    backgroundColor: 'rgb(100 109 113)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    fontSize: '2.5rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
    transition: 'background-color 0.3s',
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  listItem: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
    overflow: 'hidden',
    borderLeft: '4px solid #2fb2e7',
  },
  listHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.5rem 2rem',
    cursor: 'pointer',
    userSelect: 'none',
    borderBottom: '1px solid #eee',
  },
  diagnosisTitle: {
    fontSize: '1.2rem',
    fontWeight: 600,
    color: '#333',
  },
  expandIcon: {
    fontSize: '1.5rem',
    color: '#777',
    transition: 'transform 0.3s',
  },
  expandedIcon: {
    transform: 'rotate(180deg)',
  },
  details: {
    padding: '1.5rem 2rem',
    borderTop: '1px solid #f0f0f0',
  },
  detailRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '0.75rem',
  },
  detailLabel: {
    fontSize: '0.9rem',
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  detailValue: {
    fontSize: '1rem',
    fontWeight: 500,
    color: '#555',
  },
  actions: {
    display: 'flex',
    gap: '0.75rem',
    marginTop: '1.5rem',
  },
  actionButton: {
    padding: '0.75rem 1.5rem',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    color: 'white',
    fontWeight: 500,
    transition: 'background-color 0.3s',
  },
  editButton: {
    backgroundColor: '#2fb2e7',
  },
  deleteButton: {
    backgroundColor: '#dc3545',
  },
};

const courseData = [
  { sNo: 1, courseNo: 1, diagnosis: 'LIGAMENT INJURY LEFT KNEE', videoInfo: 'Exercise Info - 0 Days', entryDate: '07-02-2022' },
  { sNo: 2, courseNo: 1, diagnosis: 'LIGAMENT INJURY RIGHT KNEE', videoInfo: 'Exercise Info - 0 Days', entryDate: '07-02-2022' },
  { sNo: 3, courseNo: 1, diagnosis: 'LIGAMENT INJURY BOTH KNEE', videoInfo: 'Exercise Info - 0 Days', entryDate: '07-02-2022' },
  { sNo: 4, courseNo: 1, diagnosis: 'LOWER BACK PAIN', videoInfo: 'Exercise Info - 0 Days', entryDate: '07-02-2022' },
  { sNo: 5, courseNo: 1, diagnosis: 'CERVICAL SPONDYLITIS', videoInfo: 'Exercise Info - 0 Days', entryDate: '07-02-2022' },
  { sNo: 6, courseNo: 1, diagnosis: 'SHOULDER DISLOCATION LEFT', videoInfo: 'Exercise Info - 0 Days', entryDate: '07-02-2022' },
  { sNo: 7, courseNo: 1, diagnosis: 'SHOULDER DISLOCATION RIGHT', videoInfo: 'Exercise Info - 0 Days', entryDate: '07-02-2022' },
];

const CourseVideo = () => {
  const [expandedItem, setExpandedItem] = useState(null);

  const toggleDetails = (sNo) => {
    setExpandedItem(expandedItem === sNo ? null : sNo);
  };

  const handleEdit = (sNo) => console.log(`Edit item with S.No: ${sNo}`);
  const handleDelete = (sNo) => console.log(`Delete item with S.No: ${sNo}`);

  return (
    <div className="course-container">
      <div style={styles.header}>
        <h2 style={styles.headerTitle}>Course Video - List</h2>
        <button style={styles.addButton}>+</button>
      </div>
      <div style={styles.listContainer}>
        {courseData.map((item) => (
          <div key={item.sNo} style={styles.listItem}>
            <div style={styles.listHeader} onClick={() => toggleDetails(item.sNo)}>
              <div style={styles.diagnosisTitle}>{item.diagnosis}</div>
              <span
                style={{
                  ...styles.expandIcon,
                  ...(expandedItem === item.sNo && styles.expandedIcon),
                }}
              >
                &#9660;
              </span>
            </div>
            {expandedItem === item.sNo && (
              <div style={styles.details}>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Course No:</span>
                  <span style={styles.detailValue}>{item.courseNo}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Entry Date:</span>
                  <span style={styles.detailValue}>{item.entryDate}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Video:</span>
                  <span style={styles.detailValue}>{item.videoInfo}</span>
                </div>
                <div style={styles.actions}>
                  <button
                    onClick={() => handleEdit(item.sNo)}
                    style={{ ...styles.actionButton, ...styles.editButton }}
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(item.sNo)}
                    style={{ ...styles.actionButton, ...styles.deleteButton }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseVideo;
